import Rect from "./Rect"
import BaseContainer from "./BaseContainer"
export default class TipsWidget extends BaseContainer{
    constructor(bg){
        super();

        this._bg = bg || this._getDefaultBg();
        this.addChild(this._bg);
        
        this._lab = new PIXI.Text();
        this.addChild(this._lab);

        this.leftPad = this.rightPad = this.topPad = this.bottomPad = 0;
    }

    set text(text){
        this._lab.text = text;
        this.dirty();
    }
    get text(){
        return this._lab.text;
    }
    /**
     * @param {PIXI.TextStyle} style
     */
    set textStyle(style){
        this._lab.style = style;
        this.dirty();
    }

    get textStyle(){
        return this._lab.style;
    }

    get bg(){
        return this._bg;
    }

    /**
     * @param {Array | Number} paddings
     */
    set paddings(paddings){
        if((typeof paddings) == "number"){
            this.leftPad = this.rightPad = this.topPad = this.bottomPad = paddings;
        } else {
            [this.topPad, this.rightPad, this.bottomPad, this.leftPad] = paddings;
        }
        this.dirty();
    }

    redraw(){
        let width = this._lab.width;
        let height = this._lab.height;
        width += this.leftPad + this.rightPad; 
        height += this.topPad + this.bottomPad;
        this.bg.width = width;
        this.bg.height = height;
        const ox = - this.pivot.x * width;
        const oy = - this.pivot.y * height;

        this._lab.x = ox + this.leftPad;
        this._lab.y = oy + this.topPad;
        this.bg.x = ox;
        this.bg.y = oy;
    }

    _getDefaultBg(){
        return new Rect({lineWidth:1,lineColor:0, lineAlpha:0.3, shadowX: 1, shadowY: 1, shadowColor: 0x000000, shadowAlpha:0.5, fillColor:0xffffff});
    }
}


// WEBPACK FOOTER //
// ./src/common/scripts/pixi/component/TipsWidget.js